<template>
  <div>
    <AboutMeContent1/>
  </div>

</template>

<script>
  import AboutMeContent1 from '@/pages/about-me-content/AboutMeContent1.vue'
  export default {
    name: 'AboutMe',
    components:{AboutMeContent1}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/AboutMe.vue